import _implicitStylesheets from "./authorByline.css";
import _implicitScopedStylesheets from "./authorByline.scoped.css?scoped=true";
import _axImage from "ax/image";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<a class="axwp-author-byline__name${0}"${"a0:href"}${2}>${"t1"}</a>`;
const $fragment2 = parseFragment`<span class="axwp-author-byline__name${0}"${2}>${"t1"}</span>`;
const stc0 = {
  classMap: {
    "axwp-author-byline": true
  },
  key: 0
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {c: api_custom_element, d: api_dynamic_text, sp: api_static_part, st: api_static_fragment, h: api_element} = $api;
  return [api_element("div", stc0, [$cmp.hasAuthorImage ? api_custom_element("ax-image", _axImage, {
    props: {
      "variant": "circle",
      "imgSrc": $cmp.image,
      "width": "2rem",
      "height": "2rem"
    },
    key: 1
  }) : null, $cmp.hasAuthorLink ? api_static_fragment($fragment1, 3, [api_static_part(0, {
    attrs: {
      "href": $cmp.link
    }
  }, null), api_static_part(1, null, api_dynamic_text($cmp.name))]) : null, !$cmp.hasAuthorLink ? api_static_fragment($fragment2, 5, [api_static_part(1, null, api_dynamic_text($cmp.name))]) : null])];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-2q62e786pkp";
tmpl.legacyStylesheetToken = "undefined-_authorByline";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
